<template>
  <v-container class="ma-0 pa-0">
    <router-link :to="{name: 'Dashboard'}">
     <div
class="logo text-xs-right hidden-sm-and-down"
        :style="$vuetify.breakpoint.smAndDown && 'margin-left:0px !important'">
    <svg
version="1.1" x="0px" y="0px"
      viewBox="0 0 128 20" style="enable-background:new 0 0 128 20;" xml:space="preserve">

      <path
class="st1" d="M38,12.6c-0.1,1.5-0.7,2.7-1.7,3.6c-1,0.9-2.3,1.3-4,1.3c-1.8,0-3.2-0.6-4.2-1.8s-1.5-2.9-1.5-5V9.8
        c0-1.3,0.2-2.5,0.7-3.6c0.5-1,1.2-1.8,2-2.4C30.2,3.3,31.2,3,32.4,3c1.6,0,2.9,0.4,3.9,1.3s1.6,2.1,1.7,3.6h-2.9
        c-0.1-0.9-0.3-1.6-0.8-2c-0.4-0.4-1.1-0.6-2-0.6c-1,0-1.7,0.3-2.2,1s-0.7,1.8-0.7,3.2v1.1c0,1.5,0.2,2.6,0.7,3.3s1.2,1,2.2,1
        c0.9,0,1.6-0.2,2-0.6c0.4-0.4,0.7-1,0.8-1.9H38V12.6z"/>
      <path
class="st1" d="M45.7,17.3c-0.1-0.3-0.2-0.6-0.3-0.9c-0.7,0.8-1.5,1.1-2.6,1.1c-1,0-1.9-0.3-2.5-0.9c-0.7-0.6-1-1.3-1-2.2
        c0-1.1,0.4-2,1.2-2.5c0.8-0.6,2-0.9,3.5-0.9h1.3v-0.6c0-0.5-0.1-0.9-0.4-1.2c-0.2-0.3-0.6-0.4-1.2-0.4c-0.5,0-0.8,0.1-1.1,0.3
        s-0.4,0.5-0.4,0.9h-2.8c0-0.6,0.2-1.2,0.6-1.7c0.4-0.5,0.9-0.9,1.6-1.2c0.7-0.3,1.4-0.4,2.3-0.4c1.3,0,2.3,0.3,3.1,1
        c0.8,0.6,1.1,1.6,1.1,2.7v4.5c0,1,0.1,1.7,0.4,2.2v0.2C48.5,17.3,45.7,17.3,45.7,17.3z M43.4,15.4c0.4,0,0.8-0.1,1.1-0.3
        s0.6-0.4,0.8-0.7v-1.8h-1c-1.4,0-2.1,0.5-2.2,1.4v0.2c0,0.3,0.1,0.6,0.4,0.9C42.7,15.2,43,15.4,43.4,15.4z"/>
      <path
class="st1" d="M55.9,14.4c0-0.3-0.2-0.6-0.5-0.8s-0.9-0.4-1.6-0.5c-2.5-0.5-3.7-1.6-3.7-3.2c0-0.9,0.4-1.7,1.2-2.3
        C52,7,53,6.7,54.2,6.7c1.3,0,2.4,0.3,3.2,0.9S58.6,9,58.6,10h-2.8c0-0.4-0.1-0.7-0.4-1c-0.3-0.3-0.7-0.4-1.2-0.4s-0.8,0.1-1.1,0.3
        s-0.4,0.5-0.4,0.8s0.1,0.6,0.4,0.7c0.3,0.2,0.8,0.4,1.5,0.5s1.3,0.3,1.8,0.5c1.5,0.5,2.2,1.5,2.2,2.8c0,0.9-0.4,1.7-1.2,2.3
        c-0.8,0.6-1.9,0.9-3.2,0.9c-0.9,0-1.6-0.2-2.3-0.5s-1.2-0.7-1.6-1.3c-0.4-0.5-0.6-1.1-0.6-1.8h2.6c0,0.5,0.2,0.9,0.5,1.1
        c0.3,0.3,0.8,0.4,1.4,0.4c0.5,0,0.9-0.1,1.2-0.3C55.8,15,55.9,14.7,55.9,14.4z"/>
      <path
class="st1" d="M65.2,17.5c-1.5,0-2.8-0.5-3.7-1.4c-1-0.9-1.4-2.2-1.4-3.7v-0.3c0-1,0.2-2,0.6-2.8c0.4-0.8,1-1.5,1.7-1.9
        s1.6-0.7,2.5-0.7c1.4,0,2.5,0.4,3.4,1.3c0.8,0.9,1.2,2.2,1.2,3.8V13h-6.6c0.1,0.7,0.4,1.2,0.8,1.6c0.5,0.4,1,0.6,1.7,0.6
        c1.1,0,1.9-0.4,2.5-1.2l1.4,1.5c-0.4,0.6-1,1.1-1.7,1.4C66.8,17.3,66,17.5,65.2,17.5z M64.9,8.9c-0.6,0-1,0.2-1.3,0.6
        c-0.3,0.4-0.6,0.9-0.7,1.6h3.9v-0.2c0-0.6-0.2-1.1-0.5-1.4C65.9,9.1,65.5,8.9,64.9,8.9z"/>
      <path
class="st1" d="M80.4,12.2c0,1.7-0.4,3-1.1,3.9c-0.7,0.9-1.7,1.4-3,1.4c-1.1,0-2-0.4-2.7-1.3l-0.1,1.1H71V2.5h2.8v5.3
        c0.6-0.8,1.5-1.1,2.5-1.1c1.3,0,2.3,0.5,3,1.4s1.1,2.2,1.1,3.9V12.2z M77.6,12c0-1.1-0.2-1.8-0.5-2.3S76.3,9,75.6,9
        c-0.9,0-1.5,0.4-1.8,1.1v4.1c0.3,0.7,1,1.1,1.8,1.1c0.9,0,1.5-0.4,1.8-1.3C77.6,13.5,77.6,12.8,77.6,12z"/>
      <path class="st1" d="M85.1,17.3h-2.8V2.5h2.8V17.3z"/>
      <path
class="st1" d="M86.9,12c0-1,0.2-2,0.6-2.8s1-1.4,1.7-1.9c0.7-0.4,1.6-0.7,2.6-0.7c1.4,0,2.6,0.4,3.4,1.3
        c0.9,0.9,1.4,2,1.5,3.5v0.7c0,1.6-0.4,2.9-1.3,3.8c-0.9,1-2.1,1.4-3.6,1.4S89.2,17,88.3,16c-0.9-1-1.3-2.3-1.3-3.9L86.9,12L86.9,12
        z M89.7,12.2c0,1,0.2,1.7,0.6,2.3c0.4,0.5,0.9,0.8,1.6,0.8s1.2-0.3,1.6-0.8C93.8,14,94,13.1,94,12c0-1-0.2-1.7-0.6-2.3
        c-0.4-0.5-0.9-0.8-1.6-0.8s-1.2,0.3-1.6,0.8C89.9,10.3,89.7,11.1,89.7,12.2z"/>
      <path
class="st1" d="M102.8,15.2c0.5,0,0.9-0.1,1.3-0.4c0.3-0.3,0.5-0.7,0.5-1.1h2.6c0,0.7-0.2,1.4-0.6,1.9c-0.4,0.6-0.9,1-1.6,1.4
        c-0.7,0.3-1.4,0.5-2.2,0.5c-1.5,0-2.7-0.5-3.5-1.4c-0.9-0.9-1.3-2.3-1.3-3.9V12c0-1.6,0.4-2.9,1.3-3.8c0.9-1,2-1.4,3.5-1.4
        c1.3,0,2.3,0.4,3.1,1.1s1.2,1.7,1.2,3h-2.6c0-0.5-0.2-1-0.5-1.3s-0.7-0.5-1.3-0.5c-0.6,0-1.1,0.2-1.5,0.7c-0.3,0.5-0.5,1.2-0.5,2.3
        v0.3c0,1.1,0.2,1.8,0.5,2.3C101.7,15,102.2,15.2,102.8,15.2z"/>
      <path class="st1" d="M112.6,13.1l-1,1v3.2h-2.8V2.5h2.8v8.2l0.5-0.7l2.7-3.1h3.3l-3.8,4.3l4.1,6.1h-3.2L112.6,13.1z"/>
      <path
class="st1" d="M125,14.4c0-0.3-0.2-0.6-0.5-0.8s-0.9-0.4-1.6-0.5c-2.5-0.5-3.7-1.6-3.7-3.2c0-0.9,0.4-1.7,1.1-2.3
        c0.8-0.6,1.8-0.9,3-0.9c1.3,0,2.4,0.3,3.2,0.9c0.8,0.6,1.2,1.4,1.2,2.4h-2.8c0-0.4-0.1-0.7-0.4-1s-0.7-0.4-1.2-0.4
        s-0.8,0.1-1.1,0.3c-0.3,0.2-0.4,0.5-0.4,0.8s0.1,0.6,0.4,0.7c0.3,0.2,0.8,0.4,1.5,0.5s1.3,0.3,1.8,0.5c1.5,0.5,2.2,1.5,2.2,2.8
        c0,0.9-0.4,1.7-1.2,2.3c-0.8,0.6-1.9,0.9-3.2,0.9c-0.9,0-1.6-0.2-2.3-0.5c-0.7-0.3-1.2-0.7-1.6-1.3c-0.4-0.5-0.6-1.1-0.6-1.8h2.6
        c0,0.5,0.2,0.9,0.5,1.1c0.3,0.3,0.8,0.4,1.4,0.4c0.5,0,0.9-0.1,1.2-0.3C124.8,15,125,14.7,125,14.4z"/>
        <path
class="st1" d="M14.5,14.5c1.6-1.5,2.5-3.6,2.5-6c0-4.6-3.8-8.4-8.4-8.4S0.2,3.9,0.2,8.5c0,2.3,0.9,4.4,2.5,5.9l3-3
          c-0.8-0.8-1.2-1.8-1.2-3c0-2.3,1.9-4.2,4.2-4.2s4.2,1.9,4.2,4.2c0,1.2-0.5,2.2-1.2,3L14.5,14.5z"/>
    </svg>
      <div class="logo-diamond">
        <svg
version="1.1" x="0px" y="0px"
      viewBox="0 0 6 6" style="enable-background:new 0 0 6 6;" xml:space="preserve">
        <rect x="1" y="1" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -1.2426 3)"  width="4.1" height="4.1"/>
        </svg>
      </div>
    </div>
      <img
      height="30px"
      src="../assets/mobile-xs-icon.svg"
      class="text-xs-right mt-2 hidden-md-and-up"/>
      </router-link>
  </v-container>
</template>

<script>
export default {
  name: "Logo",
  data: () => ({ hideMenu: false }),
  props: {},
  watch: {
    hideMenu: function() {
      document.body.className = this.hideMenu ? "menuClosed" : ""
    }
  }
}
</script>

<style>

.aside-menus,
.menu-toggle {
  opacity: 1;
  transition: opacity 0.25s;
}

.logo-wrapper {
  width:277px;
  height:100%;
  border-right:1px solid rgba(255,255,255,0.2);
  padding:0 24px 0 0;
}

.logo {
  width:172px;
  position:relative;
  margin:11px 0 0 39px;
}

.logo svg {
  width:100%;
  display:block;
  fill:white;
}

.logo-diamond {
  position:absolute;
  top:20px;
  left:8px;  width:6px;
  height:6px;
  display:block;
}

.logo-diamond svg {
  fill:#faa92b !important;
  width:10px;
  height:10px;
  display:block;
}

.white-menu-theme .logo svg {
  fill:#1d303e;
}
</style>
